import Vue from 'vue'
import { isArray } from 'lodash'
import moment from 'moment'

/**
 * Returns an array from any kind of value.
 */
export function arrify (value: any): any[] {
  if (value === undefined || value === null) {
    return []
  }

  return isArray(value) ? value : [value]
}

/**
 * Returns a user readable date string.
 */
export function dateToString (date: number) {
  // return moment(date).format('MM/DD/YYYY')
  return moment(date).format('MMMM Do YYYY')
}

/**
 * Converts a decimal into a percent value between 0 and 100.
 * @param value
 */
export function decimalToPercent (value: number) {
  return Math.floor(value * 100)
}

/**
 * Returns a new instance of an empty array.
 */
export function emptyArray (): [] {
  return []
}

/**
 * Returns a new instance of an empty object.
 */
export function emptyObject (): object {
  return {}
}

/**
 * Updates an object based on key maintaining reactiveness.
 * @param source
 * @param updates
 * @param key
 */
export function updateVueObject (source: any, updates: any, key: string) {
  updates = arrify(updates)

  for (let i = 0, length = updates.length; i < length; i++) {
    Vue.set(source, updates[i][key], updates[i])
  }

  return source
}
